import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Select } from '../../../../../CommonComponents/OPL/Select/Select/Select';
import { InsuranceDTO } from '../../../api/useInsuranceQuery';
import { FormFields } from '../../../components/UpsertInsuranceModal/UpsertInsuranceModal.meta';

interface Props {
  data: InsuranceDTO;
}

export const HealthInsuredMembersSelect = ({ data }: Props) => {
  const formBag = useFormContext<FormFields>();

  const options = data.Options.HealthInsuredMembersOptions;

  return (
    <Controller
      name="HealthInsuredMembers"
      control={formBag.control}
      render={({ field: { value, onChange } }) => (
        <Select
          isMulti
          label="Insured Members"
          placeholder="Select insured members..."
          value={value ? options.filter(opt => value.includes(opt.value)) : []}
          options={options}
          onChange={opts => onChange(opts.map(opt => opt.value))}
          closeMenuOnSelect={false}
          isPortal
          isClearable
        />
      )}
    />
  );
};
